// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"

import {toDinero} from "../../../util"
import PriceInput from "../../price-input"
import Icon from "../../icon"
import {removeInvoiceItem, updateInvoiceItem} from "../../../actions/invoice"
import type {
  Dispatch,
  Invoice,
  InvoiceItem,
  InvoiceItemKeyType,
  State as ReduxState,
} from "../../../types"

type Props = {
  +dispatch: Dispatch,
  +invoice: ?Invoice,
  +item: InvoiceItem,
  +itemKey: InvoiceItemKeyType,
  +isEditable: boolean,
  +isFinal: boolean,
}

class InvoiceItemRow extends React.Component<Props> {
  handleRemoveComplete: () => void
  handleCostUpdate: (string, string) => void

  static defaultProps = {
    isEditable: true,
    isFinal: false,
  }

  constructor(props: Props) {
    super(props)

    this.handleCostUpdate = this.handleCostUpdate.bind(this)
    this.handleRemoveComplete = this.handleRemoveComplete.bind(this)
  }

  handleCostUpdate(property: string, value: string) {
    const {dispatch, invoice, item} = this.props
    if (invoice) {
      dispatch(updateInvoiceItem(invoice.id, item.id, {cost: value}))
    }
  }

  handleRemoveComplete() {
    const {dispatch, invoice, item} = this.props
    if (invoice) {
      dispatch(removeInvoiceItem(invoice.id, item.id))
    }
  }

  renderExportLinks() {
    const {item, itemKey} = this.props
    return itemKey === "baby_list_invoice" ? (
      <React.Fragment>
        <a
          href={item.babyListInvoicePdfPath}
          rel="noopener noreferrer"
          target="_blank"
        >
          pdf
        </a>{" "}
        <a
          href={item.babyListInvoiceCsvPath}
          rel="noopener noreferrer"
          target="_blank"
        >
          csv
        </a>
      </React.Fragment>
    ) : null
  }

  renderMetaInfo() {
    const {item, itemKey} = this.props
    const baseCost =
      itemKey === "baby_list_item" ? (
        <em className="text-muted small">
          ({toDinero(item.costBase).toFormat("$0,0.00")})
        </em>
      ) : null
    const clientName =
      itemKey === "license_fee" ? (
        <em className="text-muted small">
          ({item.clientName} - {item.listType})
        </em>
      ) : null

    return (
      <React.Fragment>
        {baseCost} {clientName}
      </React.Fragment>
    )
  }

  renderCostField() {
    const {item, itemKey, isFinal} = this.props

    if (itemKey === "license_fee" && !isFinal) {
      return (
        <div className="d-flex align-items-center">
          <span className="d-inline-block mr-2">€</span>
          <PriceInput
            name="cost"
            className="form-control form-control-sm text-right"
            id={`cost[${item.cost}]`}
            value={item.cost}
            onChange={this.handleCostUpdate}
          />
        </div>
      )
    }

    return toDinero(item.cost).toFormat("$0,0.00")
  }

  render() {
    const {item, itemKey, isFinal} = this.props
    const costClass = ClassNames("text-right is-nfw", {
      "is-zero": item.cost === "0" && itemKey !== "baby_list_invoice",
    })
    const allowEdit = !isFinal
    const metaInfo = this.renderMetaInfo()
    const exportLinks = this.renderExportLinks()
    const costField = this.renderCostField()
    return (
      <tr key={`invoice-item-${item.id}`} className="invoice-row">
        <td>
          {item.description} {metaInfo}
          {item.supplierId}
        </td>
        <td className="text-center">
          {itemKey === "baby_list_invoice" ? exportLinks : item.amount}
        </td>
        <td className={costClass}>{costField}</td>
        {allowEdit ? (
          <td className="invoice-row-actions">
            <button
              className="btn btn-icon"
              onClick={this.handleRemoveComplete}
            >
              <Icon name="icon-bin" />
            </button>
          </td>
        ) : (
          <td className="invoice-row-actions py-4"> </td>
        )}
      </tr>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  invoice: state.invoice.invoice,
})

export default connect(mapStateToProps)(InvoiceItemRow)
